export default __webpack_public_path__ + "static/hero_contact-e0fe5732ec996be797a12b3e3e8f8dda.jpeg";